export default "__VITE_ASSET__Bj5hS9gJ__"